import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { MessageErrorResolver } from '../../utilities/message-error-resolver';
import { LoadingService } from './loading.service';
import { ArenaFilterForm } from '@models/arena/filters/arena-filter-form';
import { PageRequest } from '@models/pagination/page-request';
import { catchError, map, Observable } from 'rxjs';
import { IPage } from '@models/pagination/page';
import { IArenaDto } from '@models/arena/dtos/arena-dto';
import { ResponseDto } from '@models/exceptions/response-dto';
import { ArenaPostForm } from '@models/arena/forms/arena-post-form';
import { StreetPostForm } from '@models/arena/forms/street-post-form';
import { ModalSpaceForm } from '@models/arena/forms/modal-space-form';
import { ModalSpaceDto } from '@models/arena/dtos/modal-space-dto';
import { ModalSpacePostForm } from '@models/arena/forms/modal-space-post-form';
import { toParams } from '../../utilities/utility-functions';


@Injectable({
  providedIn: 'root'
})
export class ArenaService {
private url: string = environment.apiUrl + '/v1/arenas';

  constructor(
    private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService
  ) {}

  public findArenas$(
    filters: ArenaFilterForm,
    pageRequest: PageRequest
  ): Observable<IPage<IArenaDto>> {
    let params =toParams(filters,pageRequest)
   /* if (pageRequest.size) params = params.set('size', pageRequest.size);
    if (pageRequest.page) params = params.set('page', pageRequest.page);
    if (filters.areTxNome) params = params.set('areTxNome', filters.areTxNome);
    if (filters.areTxDescricao) params = params.set('areTxDescricao', filters.areTxDescricao);*/

    return this.httpClient
      .get<ResponseDto<IPage<IArenaDto>>>(this.url, { params })
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }

  public findSpacesByAreNrId(areNrId:number):Observable<IPage<ModalSpaceDto>>{
    return this.httpClient.get<ResponseDto<IPage<ModalSpaceDto>>>(`${this.url}/${areNrId}/espacos`).pipe(
      map((response) => response.response),
      catchError((err) => {
        this.loadingService.deactivate();
        this.messageErrorResolver.resolveMessage(err);
        throw err;
      })
    );
  }
  public deleteArenaById(areNrId:number,epcNrId:number):Observable<IArenaDto>{
    return this.httpClient.delete<ResponseDto<IArenaDto>>(`${this.url}/${areNrId}/espacos/${epcNrId}`).pipe(
      map((response) => response.response),
      catchError((err) => {
        this.loadingService.deactivate();
        this.messageErrorResolver.resolveMessage(err);
        throw err;
      })
    );
  }
  public deleteArena(areNrId:number):Observable<void>{
    return this.httpClient.delete<void>(`${this.url}/${areNrId}`).pipe(
      catchError((err) => {
        this.loadingService.deactivate();
        this.messageErrorResolver.resolveMessage(err);
        throw err;
      })
    );
  }

  public findArenasById$(areNrId: number): Observable<IArenaDto> {
    let params = new HttpParams();
    return this.httpClient
      .get<ResponseDto<IArenaDto>>(`${this.url}/${areNrId}`, { params })
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }
  public createArena$(form: ArenaPostForm): Observable<IArenaDto> {
    return this.httpClient
      .post<ResponseDto<IArenaDto>>(this.url, form)
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }
  public createOrEditStreet$(areNrId: number, form: StreetPostForm): Observable<IArenaDto> {
    return this.httpClient
      .post<ResponseDto<IArenaDto>>(`${this.url}/${areNrId}/logradouro`, form)
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }
  public createOrEditModalSpace$(areNrId: number, form: ModalSpacePostForm):Observable<IArenaDto>{
    return this.httpClient
      .put<ResponseDto<IArenaDto>>(`${this.url}/${areNrId}/espacos`,form)
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }
  public editArena$(form: ArenaPostForm): Observable<IArenaDto> {
    return this.httpClient
      .put<ResponseDto<IArenaDto>>(this.url, form)
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }

  //Descomentar services abaixo e refatorar para arenas
  // public saveDraw$(form: DrawPostForm): Observable<IDrawDto> {
  //   return this.httpClient
  //     .post<ResponseDto<IDrawDto>>(`${this.url}`, form)
  //     .pipe(
  //       map((response) => response.response),
  //       catchError((err) => {
  //         this.loadingService.deactivate();
  //         this.messageErrorResolver.resolveMessage(err);
  //         throw err;
  //       })
  //     );
  // }

  // public editDraw$(sorNrId: number, form: DrawPostForm): Observable<IDrawDto> {
  //   return this.httpClient
  //     .put<ResponseDto<IDrawDto>>(`${this.url}/${sorNrId}`, form)
  //     .pipe(
  //       map((response) => response.response),
  //       catchError((err) => {
  //         this.loadingService.deactivate();
  //         this.messageErrorResolver.resolveMessage(err);
  //         throw err;
  //       })
  //     );
  // }
}
